<template>
  <div
    class="h-full flex items-center justify-center overflow-hidden"
    @click.stop.prevent="showError()"
    :class="!!state && validIcon ? 'w-10 min-w-10' : 'w-6 min-w-6'"
  >
    <Transition name="fade" mode="out-in">
      <div v-if="state === 'INVALID'" class="rounded-full bg-red-100 size-5 flex items-center justify-center">
        <i class="icon-alert-circle text-red-300 text-xl"></i>
      </div>
      <IonSpinner name="lines-small" v-else-if="state === 'VALIDATING'"></IonSpinner>
      <i
        v-else-if="validIcon"
        :class="{
          [validIcon]: true,
          'text-blue-500': validIconColor === 'blue',
          'text-gray-500': validIconColor === 'gray',
        }"
      ></i>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { FormControlError, FormControlState } from '@/composables/use-form-control';
import { useToast } from '@/composables/use-toast';
import { IonSpinner } from '@ionic/vue';

const props = withDefaults(
  defineProps<{
    validIcon?: string;
    validIconColor?: 'blue' | 'gray';
    errors?: FormControlError[];
    state?: FormControlState;
  }>(),
  { validIconColor: 'blue' }
);

const toast = useToast();

async function showError() {
  if (props.errors?.[0]) {
    await toast.errorToast(props.errors?.[0]?.msg || 'Something went wrong', { duration: 5000 });
  }
}
</script>

<style scoped></style>
